import React, { useRef } from "react";
import classes from "./Reportinvoice.module.css";
import HeaderNav from "../../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BarChart2,
  Filter,
  CalendarClock,
  ArrowLeft,
  Mail,
  Printer,
  Download,
  Settings,
} from "lucide-react";
import Footer from "../../../Components/Footer/Footer";

const Preview = () => {
  const componentRef = useRef(null);

  const location = useLocation();
  const navigate = useNavigate();
  const receipt = location.state?.receipt || location.state?.invoice;
  // const receiptFrom =
  //   receipt?.customer?.name || receipt?.particular || "—";
  const receiptData = receipt || {};
  const receiptNo = receiptData.teller_number || "—"; // or generate dynamically
  const paymentModeMap = {
    1: "Cash",
    2: "Cheque",
    3: "Transfer",
  };
  const paymentModes = {
    1: "Bank Transfer",
    2: "Cheque",
    3: "Teller",
    4: "Cash",
    // add more if needed
  };

  const paymentMode = paymentModes[receipt.payment_mode] || "—";

  const receiptFrom =
    receiptData.particulars || "—";

  const {
    reference,
    transactionDate,
    description,
    selectedCurrency,
    selectedPaymentMode,
    debitAccount,
    totalAmount,
    rows,
  } = receipt || {};

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  if (!receipt) {
    return (
      <div className={classes.errorPage}>
        <h2>Receipt data not found.</h2>
        <button onClick={() => navigate("/dashboard")}>Go to Dashboard</button>
      </div>
    );
  }

  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <div>
        <div className={classes.noPrint}>
          <HeaderNav activePage={pageMap[location.pathname]} />
        </div>

        <div className={classes.Container}>
        {/* Action Buttons */}
        <div className={classes.actions}>
          <button className={classes.btns}>New Receipt</button>
          <button className={classes.btns}>All Receipts</button>
          <button className={`${classes.btns} ${classes.greens}`}>Reports</button>
        </div>

        <div className={classes.act}>
          <form className={classes.form}>
            <div className={classes.group}>
              <label>Period:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>Current month</option>
                  <option>Cash</option>
                  <option>Cheque</option>
                  <option>Transfer</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>

            <div className={classes.group1}>
              <label>Group by:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>None</option>
                  <option>Cash</option>
                  <option>Cheque</option>
                  <option>Transfer</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>

            <div className={classes.group1}>
              <label>Start Date:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>30/02/25</option>
                  <option>12/07/25</option>
                  <option>03/04/25</option>
                  <option>27/01/25</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>

            <div className={classes.group1}>
              <label>End Date:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>30/02/25</option>
                  <option>12/07/25</option>
                  <option>03/04/25</option>
                  <option>27/01/25</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>

            <div className={classes.group1}>
              <button className={classes.greenBtn}>
                <BarChart2 size={16} style={{ marginRight: "6px" }} />
                Run Report
              </button>
            </div>
          </form>

          <div className={classes.iconbars}>
            <div className={classes.iconbarr}>
              <div className={classes.iconbar}>
                <Filter size={16} style={{ marginRight: "6px" }} /> Filter
              </div>
              <div className={classes.iconbar}>
                <CalendarClock size={16} style={{ marginRight: "6px" }} /> Schedule
              </div>
            </div>
          </div>
        </div>

        {/* Back Button */}
        <div className={classes.matron}>
          <button
            className={classes.backButton}
            onClick={() => navigate(-1)}
          >
            <ArrowLeft size={16} style={{ marginRight: "6px" }} /> Back
          </button>
        </div>

        <div className={`${classes.containere}`} ref={componentRef}>
            {/* Green Header Section */}
            <div className={classes.greenHeader}>
              <div className={classes.headerLeft}>
                <h1 className={classes.headerTitle}>Promix Accounting Ltd</h1>
                <p className={classes.headerAddress}>123 Business District, Victoria Island</p>
                <p className={classes.headerAddress}>Lagos, Nigeria</p>
              </div>
              <div className={classes.headerRight}>
                <button type="button" className={classes.receiptButton} onClick={handlePrint}>
                  RECEIPT
                </button>
                {/* Contact Info */}
                <div className={classes.contactInfo}>
                  <p>hello@promix.com</p>
                  <p>+234 801 234 5678</p>
                </div>
              </div>
            </div>



            {/* Received From & Date Section */}
            <div className={classes.receiptInfo}>
              <div className={classes.receivedFromSection}>
                <h3 className={classes.sectionLabel}>RECEIVED FROM</h3>
                <p className={classes.customerName}>{reference || receiptFrom || "—"}</p>
                <p className={classes.receiptNo}>Receipt No: {receipt.teller_number || `REC-${Date.now()}`}</p>
              </div>
              <div className={classes.dateSection}>
                <h3 className={classes.sectionLabel}>DATE</h3>
                <p className={classes.dateValue}>{transactionDate || "—"}</p>
                <p className={classes.paymentModeLabel}>Payment Mode:</p>
              </div>
            </div>

            {/* Divider */}
            {/* <div className={classes.divider}></div> */}

            {/* Receipt Table */}
            <div className={classes.tableContainer}>
              <table className={classes.receiptTable}>
                <thead>
                  <tr className={classes.tableHeader}>
                    <th className={classes.columnAccount}>ACCOUNT</th>
                    <th className={classes.columnCode} style={{ textAlign: 'center' }}>CODE</th>
                    <th className={classes.columnAmount} style={{ textAlign: 'right' }}>AMOUNT</th>
                  </tr>
                </thead>
                <tbody>
                  {rows?.map((row, index) => (
                    <tr key={index} className={classes.tableRow}>
                      <td className={classes.columnAccount}>{row.accountDisplay || row.accountId || "—"}</td>
                      <td className={classes.columnCode}>
                        {row.accountCode || debitAccount?.gl_code || "—"}
                      </td>
                      <td className={classes.columnAmount} style={{ textAlign: "right" }}>
                        ₦{Number(row.amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Total Section */}
            <div className={classes.totalSection}>
              <div className={`${classes.iconbarss} ${classes.noPrint}`}>
                <div className={classes.iconbar}>
                  <Mail size={16} />
                </div>
                <button
                  type="button"
                  className={classes.iconbar}
                  onClick={handlePrint}
                  style={{ background: "none", border: "none", padding: 0, cursor: "pointer", display: "flex", alignItems: "center" }}
                >
                  <Printer size={16} />
                </button>
                <div className={classes.iconbar}>
                  <Download size={16} />
                </div>
                <div className={classes.iconbar}>
                  <Settings size={16} />
                </div>
              </div>
              <p className={classes.totalLabel}>TOTAL:</p>
              <p className={classes.totalAmount}>
                ₦{Number(totalAmount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
              </p>
            </div>
            <div className={classes.printFooter}>
                          Created by
                          <br />
                          <a
                            href="https://promixaccounting.com"
                            target="_blank"
                            rel="noreferrer"
                          >
                            https://promixaccounting.com
                          </a>
                        </div>
          </div>
        </div>
      </div>
    {/* </div> */}
    <div className={classes.noPrint}>
      <Footer />
    </div>
    </>
  );
};

export default Preview;
